const MR_ENRICHMENT_FIELDS = `
  iid
  approvalsLeft
  diffStatsSummary {
    additions
    changes
    deletions
  }
  pipelines(first: 2) {
    nodes {
      id
      active
      latest
      mergeRequestEventType
      status
      totalJobs: jobs(retried: false, first: 0) {
        count
      }
      failedJobs: jobs(statuses: [FAILED, CANCELING, CANCELED], retried: false, first: 0) {
        count
      }
      passedJobs: jobs(statuses: [SUCCESS], retried: false, first: 0) {
        count
      }
    }
  }
  headPipeline {
    id
    active
    latest
    mergeRequestEventType
    status
    totalJobs: jobs(retried: false, first: 0) {
      count
    }
    failedJobs: jobs(statuses: [FAILED, CANCELING, CANCELED], retried: false, first: 0) {
      count
    }
    passedJobs: jobs(statuses: [SUCCESS], retried: false, first: 0) {
      count
    }
  }
  approvedBy {
    nodes {
      avatarUrl
      name
      username
    }
  }
  reviewers {
    nodes {
      avatarUrl
      name
      username
      mergeRequestInteraction {
        reviewState
        reviewed
      }
    }
  }
  resolvableDiscussionsCount
  resolvedDiscussionsCount
`;

// Creates a GraphQL query to enrich MRs directly by global ID.
export const createEnrichmentQuery = (mrs) => {
	const mergeRequests = mrs
		.map(
			({ id }, index) => `
				mergeRequest${index}: mergeRequest(id: ${JSON.stringify(id)}) {
					${MR_ENRICHMENT_FIELDS}
				}
			`,
		)
		.join("\n");

	return `
		query enrichMRs {
			${mergeRequests}
		}
	`;
};

export const ENRICHMENT_BATCH_SIZE = 4;
export const ENRICHMENT_CONCURRENCY = 8;
